import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import Grid from '../../../../Grid/Grid';
import EditorDeviationLink from '../../../MonoView/_partials/DeviationLink';
import Thumb from '../../../ThumbView';
const GalleryGrid = ({ deviations, layoutRowAlignment, width, layoutSpacing, extOptions, gridItemWidth, gridItemHeight, itemCropping, linkOverrides })=>{
    const getId = (idx)=>deviations[idx].deviationId;
    let breakpoints = [
        {
            maxWidth: 9999,
            elementWidth: gridItemWidth !== null && gridItemWidth !== void 0 ? gridItemWidth : extOptions.defaultGridItemWidth,
            elementHeight: gridItemHeight || extOptions.defaultGridItemHeight
        }
    ];
    // Comments force small media
    if (extOptions.smallMedia) {
        breakpoints = [
            {
                maxWidth: 9999,
                elementWidth: extOptions.defaultGridItemWidth,
                elementHeight: extOptions.defaultGridItemHeight
            }
        ];
    }
    let gridStyles = {};
    let rowAlign;
    if (layoutRowAlignment) {
        const settingToCss = {
            left: 'flex-start',
            right: 'flex-end',
            center: 'center'
        };
        gridStyles = {
            display: 'flex',
            justifyContent: settingToCss[layoutRowAlignment]
        };
        rowAlign = layoutRowAlignment;
    }
    return /*#__PURE__*/ React.createElement("div", {
        style: gridStyles,
        className: "daeditor-square-grid"
    }, /*#__PURE__*/ React.createElement(Grid, {
        rowAlign: rowAlign,
        containerWidth: width,
        breakpoints: breakpoints,
        elementCount: deviations.length,
        spacing: layoutSpacing !== null && layoutSpacing !== void 0 ? layoutSpacing : extOptions.defaultLayoutSpacing,
        rowSpacing: layoutSpacing !== null && layoutSpacing !== void 0 ? layoutSpacing : extOptions.defaultLayoutSpacing,
        getElementId: getId,
        enableScrollOptim: false,
        renderElement: (element)=>/*#__PURE__*/ React.createElement("div", {
                key: element.index,
                style: _object_spread({}, element.style),
                "data-deviation": JSON.stringify(deviations[element.index])
            }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
                link: (extOptions === null || extOptions === void 0 ? void 0 : extOptions.canLink) ? linkOverrides === null || linkOverrides === void 0 ? void 0 : linkOverrides[deviations[element.index].deviationId] : undefined,
                deviation: deviations[element.index],
                "data-deviationId": (extOptions === null || extOptions === void 0 ? void 0 : extOptions.canLink) ? deviations[element.index].deviationId : undefined
            }, /*#__PURE__*/ React.createElement(Thumb, {
                deviation: deviations[element.index],
                width: element.width,
                height: element.height,
                allowPreviewUsage: true,
                noCropping: itemCropping === 'crop' ? true : false
            })))
    }));
};
GalleryGrid.displayName = 'GalleryGrid';
export default GalleryGrid;

//# sourceMappingURL=GalleryGrid.js.map